export default __webpack_public_path__ + "static/tm-372c3218ba71e0cba76d4c707bbab30d.svg";